import { render, staticRenderFns } from "./ReviewDetailsPage.vue?vue&type=template&id=46e1c8df&scoped=true"
import script from "./ReviewDetailsPage.vue?vue&type=script&lang=js"
export * from "./ReviewDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetailsPage.vue?vue&type=style&index=0&id=46e1c8df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1c8df",
  null
  
)

export default component.exports